export const LISTING_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};

export const CHANNEL_RECORD_FILTER = {
  ALL: 'ALL',
  HAS_DRAFT: 'HAS_DRAFT',
  HAS_PUBLISHED: 'HAS_PUBLISHED',
  DRAFT_ONLY: 'DRAFT_ONLY',
  PUBLISHED_ONLY: 'PUBLISHED_ONLY',
};